var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleAds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7245 1.58857C12.0748 0.634284 9.96527 1.20058 9.01277 2.85344L0.462674 17.6908C-0.489779 19.3436 0.07544 21.4571 1.72516 22.4114C3.37488 23.3657 5.48439 22.7994 6.43689 21.1465L14.987 6.30921C15.9395 4.65635 15.3742 2.54285 13.7245 1.58857Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.44559 22.875C5.34854 22.875 6.89119 21.3295 6.89119 19.4229C6.89119 17.5164 5.34854 15.9708 3.44559 15.9708C1.54264 15.9708 0 17.5164 0 19.4229C0 21.3295 1.54264 22.875 3.44559 22.875Z",
    fill: "#4CAF50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5373 17.6907L14.9872 2.85344C14.0348 1.20058 11.9252 0.634284 10.2755 1.58857C8.62575 2.54285 8.06049 4.65635 9.01299 6.30921L17.5631 21.1465C18.5156 22.7994 20.6251 23.3657 22.2749 22.4114C23.9245 21.4571 24.4898 19.3436 23.5373 17.6907Z",
    fill: "#2196F3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAds);
export default __webpack_public_path__ + "static/media/GoogleAds.030aded1ab276111647d74118b60c877.svg";
export { ForwardRef as ReactComponent };